import { Calendar, CheckCircle, Briefcase, Settings, XCircle, ArchiveRestore } from 'lucide-react';
import type { EquipmentStats } from '../../types/equipment.types';
import { KpiGrid, type KpiItem } from '@/components/ui/KpiGrid';

interface EquipmentKpiGridProps {
  stats: EquipmentStats;
  isLoading?: boolean;
}

export function EquipmentKpiGrid({ stats, isLoading }: EquipmentKpiGridProps) {
  const brokenCount = (stats as any).brokenCount ?? 0;
  const retiredCount = (stats as any).retiredCount ?? 0; // The 6th KPI
  const total = stats.totalAssets || 0;

  const kpis: KpiItem[] = [
    {
      title: 'Tổng thiết bị',
      value: total,
      suffix: 'Máy',
      icon: Calendar,
      color: 'text-blue-600',
      bg: 'bg-blue-50',
      trend: 'neutral',
      trendValue: 'Tổng quan',
      chartColor: 'bg-blue-500',
      chartData: [50, 50, 50, 50, 50, 50, 50]
    },
    {
      title: 'Đang sử dụng',
      value: stats.inUseCount,
      suffix: total ? `${Math.round((stats.inUseCount / total) * 100)}%` : '0%',
      icon: CheckCircle,
      color: 'text-emerald-600',
      bg: 'bg-emerald-50',
      trend: 'up',
      trendValue: 'Hoạt động',
      chartColor: 'bg-emerald-500',
      chartData: [60, 65, 70, 75, 80, 85, 90]
    },
    {
      title: 'Sẵn sàng',
      value: stats.availableCount,
      suffix: total ? `${Math.round((stats.availableCount / total) * 100)}%` : '0%',
      icon: Briefcase,
      color: 'text-indigo-600',
      bg: 'bg-indigo-50',
      trend: 'neutral',
      trendValue: 'Lưu kho',
      chartColor: 'bg-indigo-500',
      chartData: [20, 25, 20, 15, 20, 20, 20]
    },
    {
      title: 'Bảo trì',
      value: stats.maintenanceCount,
      suffix: total ? `${Math.round((stats.maintenanceCount / total) * 100)}%` : '0%',
      icon: Settings,
      color: 'text-orange-600',
      bg: 'bg-orange-50',
      trend: 'neutral',
      trendValue: 'Định kỳ',
      chartColor: 'bg-orange-500',
      chartData: [5, 10, 5, 5, 10, 5, 5]
    },
    {
      title: 'Hư hỏng',
      value: brokenCount,
      suffix: total ? `${Math.round((brokenCount / total) * 100)}%` : '0%',
      icon: XCircle,
      color: 'text-rose-600',
      bg: 'bg-rose-50',
      trend: 'down',
      trendValue: 'Cần sửa',
      chartColor: 'bg-rose-500',
      chartData: [0, 0, 5, 0, 0, 0, 0]
    },
    {
      title: 'Thanh lý',
      value: retiredCount,
      suffix: total ? `${Math.round((retiredCount / total) * 100)}%` : '0%',
      icon: ArchiveRestore,
      color: 'text-slate-600',
      bg: 'bg-slate-100',
      trend: 'neutral',
      trendValue: 'Đã hủy',
      chartColor: 'bg-slate-500',
      chartData: [2, 2, 2, 2, 2, 2, 2]
    },
  ];

  return <KpiGrid kpis={kpis} isLoading={isLoading} />;
}
